import {readFragmentFromCache} from 'graphql-client/ApolloWrappers';
import FragmentWrapper from 'graphql-client/FragmentWrapper';
import {ProcessOutputSchema} from 'processes/ProcessConstants';
import {PROCESS_OUTPUT_SCHEMA_FRAGMENT} from 'processes/ProcessFragments';

const ProcessOutputSchemaFragment: FragmentWrapper<ProcessOutputSchema> = {
  fragment: PROCESS_OUTPUT_SCHEMA_FRAGMENT,
  fragmentName: 'ProcessOutputSchema',
};

export default function readProcessOutputSchemaFromCache(schemaId: string): ProcessOutputSchema | null {
  return readFragmentFromCache(ProcessOutputSchemaFragment, schemaId);
}
